// NotFoundPage.js
import React from "react";
import "../styles/404.css"; // Import the CSS file for animation
import Img from "../assets/images/navbar-logo.png";
const NotFoundPage = () => {
  return (
    <div className="space">
      <div className="stars"></div>
      <div className="center">
        <div className="astronaut">
          <img src={Img} alt="Astronaut" />
        </div>
        <h1 className="error-code">404</h1>
        <p className="error-message">Oops! Looks like you're lost in space.</p>
        <a href="/" className="back-home">
          Go Back to Earth
        </a>
      </div>
    </div>
  );
};

export default NotFoundPage;
